import React from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from 'react-bootstrap';
import { ExternalLinkButton } from '@rd-web-markets/shared/dist/util/buttons/ExternalLinkButton';
import { Loading } from '@rd-web-markets/shared/dist/util';
const STATUS_CONFIG = {
  processing: {
    icon: 'autorenew',
    variant: 'info',
    labelKey: 'aif_processing'
  },
  submitting: {
    icon: 'upload',
    variant: 'primary',
    labelKey: 'aif_submitting'
  },
  awaiting_approval: {
    icon: 'hourglass_empty',
    variant: 'warning',
    labelKey: 'aif_awaiting_approval'
  },
  submitted: {
    icon: 'check_circle',
    variant: 'success',
    labelKey: 'aif_submitted'
  },
  error: {
    icon: 'error',
    variant: 'danger',
    labelKey: 'aif_error'
  },
  cancelled: {
    icon: 'cancel',
    variant: 'secondary',
    labelKey: 'aif_cancelled'
  },
  undefined: {
    icon: 'cancel',
    variant: 'secondary',
    labelKey: 'aif_status_unknown'
  }
};
export default function ClaimerSubmissionStatus(_ref) {
  let {
    claim,
    status
  } = _ref;
  const {
    t
  } = useTranslation();
  const config = STATUS_CONFIG[status] || {
    icon: 'help_outline',
    variant: 'secondary',
    labelKey: null
  };
  const label = config.labelKey ? t(config.labelKey) : t('aif_submission_status_unknown');
  if (!claim) {
    return /*#__PURE__*/React.createElement(Loading, null);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center gap-2"
  }, /*#__PURE__*/React.createElement("span", null, t('aif_submission_status'), ":"), /*#__PURE__*/React.createElement(Badge, {
    bg: config.variant,
    className: "d-flex align-items-center gap-1 px-2 py-1"
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons",
    style: {
      fontSize: '18px',
      verticalAlign: 'middle'
    }
  }, config.icon), /*#__PURE__*/React.createElement("span", null, label)), (status === 'awaiting_approval' || status === undefined) && /*#__PURE__*/React.createElement(ExternalLinkButton, {
    href: "".concat(process.env.CLAIMER_HOST, "/claims/").concat(claim.claimer_aif_financial_year_id, "/dashboard/rd/aif"),
    text: status ? t('review_aif_in_claimer') : t('aif_status_unknown_please_check_status_in_claimer_system')
  }));
}